var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in-love"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3334 2.68337C17.1126 2.6725 16.8903 2.66699 16.6667 2.66699C9.30291 2.66699 3.33337 8.63653 3.33337 16.0003C3.33337 23.3641 9.30291 29.3337 16.6667 29.3337C24.0304 29.3337 30 23.3641 30 16.0003C30 14.8494 29.8542 13.7323 29.58 12.667",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3334 20C12.5495 21.6192 14.4858 22.6667 16.6667 22.6667C18.8476 22.6667 20.7839 21.6192 22 20",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0001 12.667H12.2762C11.6725 12.667 11.0936 12.9068 10.6667 13.3337M19.3334 12.667H21.0573C21.6609 12.667 22.2399 12.9068 22.6667 13.3337",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8509 3.10785C23.1024 2.37679 24.1946 2.6714 24.8508 3.14068C25.1198 3.33311 25.2542 3.42932 25.3334 3.42932C25.4126 3.42932 25.547 3.33311 25.8161 3.14068C26.4722 2.6714 27.5645 2.37679 28.816 3.10785C30.4584 4.06732 30.83 7.23261 27.0417 9.90305C26.3201 10.4117 25.9593 10.666 25.3334 10.666C24.7076 10.666 24.3468 10.4117 23.6252 9.90305C19.8369 7.23261 20.2085 4.06732 21.8509 3.10785Z",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInLove);
export default __webpack_public_path__ + "static/media/in-love.36fda662b6e1536cc05a56f9dfc64b79.svg";
export { ForwardRef as ReactComponent };